









































import Vue from 'vue';
import { UserModel } from '@/@types/member';
import { sso, HEALTHEQUITY_API_SUB_URLS } from '@/api';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';

interface Data {
  isLoading: boolean;
  ssoUrl: string;
  formData: any;
  helpContent: string;
}

export default Vue.extend({
  name: 'MigratedAlert',
  data(): Data {
    return {
      isLoading: false,
      ssoUrl: '',
      formData: {},
      helpContent: '',
    };
  },
  props: {
    bannerText: {
      type: String,
      required: false,
    },
    helpContentKey: {
      type: String,
      required: false,
    },
    helpContentVariables: {
      type: Object,
      required: false,
    },
    bannerActionText: {
      type: String,
      required: false,
    },
    bannerActionRoute: {
      type: String,
      required: false,
    },
    bannerActionUrl: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.getHelpContent();
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    displaySSOAction(): boolean {
      return this.bannerActionText && !this.bannerActionRoute && !this.bannerActionUrl && this.user.hqySsoInd;
    },
    displayBannerActionInternal(): boolean {
      return !!this.bannerActionText && !!this.bannerActionRoute && !this.bannerActionUrl;
    },
    displayBannerActionExternal(): boolean {
      return !!this.bannerActionText && !!this.bannerActionUrl && !this.bannerActionRoute;
    },
  },
  methods: {
    getHealthEquitySSO(event: boolean): void {
      this.isLoading = true;
      // Have to specifically check for true because mouse pointer events from button clicks are passed too
      if (event === true) {
        // If we get an event this means the user clicked an "action=" link rather than a button so we need to show loading a different way.
        EventBus.$emit('openModal', 'Loading');
      }
      const memberId = this.user.memberId;
      sso
        .post(`${HEALTHEQUITY_API_SUB_URLS.healthEquitySso}/${memberId}/healthequity-federations`)
        .then((response) => {
          this.ssoUrl = process.env.VUE_APP_HQY_SSO_URL;
          this.formData = response.data;

          this.$nextTick(() => {
            this.isLoading = false;
            EventBus.$emit('closeModal');
            (this.$refs.sso as any).submit();
          });
        })
        .catch(() => {
          this.isLoading = false;
          EventBus.$emit('openModal', 'Error', {
            message: 'sso-redirect-error_unable-to-perform-redirect',
          });
        });
    },
    async getHelpContent(): Promise<void> {
      if (!this.helpContentKey) {
        return;
      }

      const CONTENT_AREAS = await getContentArea(this.helpContentKey);
      let HELP_CONTENT_FIELD = CONTENT_AREAS.fields
        ? CONTENT_AREAS.fields.helpContent
        : '';
      if (HELP_CONTENT_FIELD && this.helpContentVariables) {
        HELP_CONTENT_FIELD = this.$options.filters!.varReplace(
          HELP_CONTENT_FIELD,
          this.helpContentVariables,
        );
      }
      this.helpContent = HELP_CONTENT_FIELD;
    },
  },
});
